import { render, staticRenderFns } from "./FailurePage.vue?vue&type=template&id=50a80951&scoped=true&"
import script from "./FailurePage.vue?vue&type=script&lang=js&"
export * from "./FailurePage.vue?vue&type=script&lang=js&"
import style0 from "./FailurePage.vue?vue&type=style&index=0&id=50a80951&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a80951",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
